export const SET_USERS = `SET_USERS`;
export const CLEAR_USERS = `CLEAR_USERS`;
export const SET_USER = `SET_USER`;
export const SET_REPOS = `SET_REPOS`;
export const SET_LOADING = `SET_LOADING`;
export const SET_ALERT = `SET_ALERT`;
export const HIDE_ALERT = `HIDE_ALERT`;
export const SET_QUERY = `SET_QUERY`;
export const CLEAR_QUERY = `CLEAR_QUERY`;
